import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { filter, map, take } from 'rxjs/operators';
import { RoutesConst } from '../shared/route-const';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class ImpersonationGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
  ) {}

  /**
   * Determines if the route can be activated based on AllowImpersonation.
   * Returns true if impersonation is allowed, otherwise redirects to home.
   * Waits for authentication state to be checked before evaluating.
   */
  canActivate(): import('rxjs').Observable<boolean | UrlTree> {
    // Wait for authentication state to be loaded, then check AllowImpersonation
    return this.authService.authState$.pipe(
      filter((authState) => authState.authenticationChecked), // Only proceed when authentication has been checked
      take(1), // Only take the first emitted value
      map((authState) => {
        if (authState.user.AllowImpersonation) {
          return true; // Allow route activation
        }
        return this.router.createUrlTree(['/', RoutesConst.home]); // Redirect to home if not allowed
      }),
    );
  }
}
